import apiV1 from 'redux/api/v1';
import { getLayers } from 'constants/endpoints';

export const GET_LAYER = 'project/layer/GET_LAYER';
export const GET_LAYER_LOADING = 'project/layer/GET_LAYER_LOADING';
export const GET_LAYER_FULFILLED = 'project/layer/GET_LAYER_FULFILLED';
export const GET_LAYER_REJECTED = 'project/layer/GET_LAYER_REJECTED';

export const getLayer = layer => ({
  type: GET_LAYER,
  data: { layer },
});

export const layerLoading = () => ({
  type: GET_LAYER_LOADING,
  data: { loading: true },
});

export const layerLoaded = layer => ({
  type: GET_LAYER_FULFILLED,
  data: { layer, loading: false },
});

export const layerRejected = error => ({
  type: GET_LAYER_REJECTED,
  data: { loading: false, error },
});

export function fetchLayers(id) {
  return async function (dispatch) {
    dispatch(layerLoading());
    try {
      const response = await apiV1.get(getLayers(id));
      return dispatch(layerLoaded(response));
    } catch(e) {
      return dispatch(layerRejected(e));
    }
  };
}